import React, { useState } from "react";
import PlusIcon from "../../../Setting/SettingsAssets/Plus.svg";
import { useParams } from "react-router-dom";
import ManageMedicineCards from "../../ManageMedicineCards";
import { useNavigate } from "react-router-dom";
import "./MedicineSidebar.css";
import Dropdown from "react-dropdown";
import { useAuth } from "../../../../AuthProvider";
import { useApp } from "../../../../AppProvider";
import api from "./../../../../axiosInstance"
import logger from "../../../../utils/logger";

const MedicineSidebar = ({ medicineData, setMedicineData }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { medicationGroup } = useApp();
  const { MediRecordId } = useParams();
  const [groups, setGroups] = useState();


  const createMedicineNewData = async (groupName) => {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/medicationGroups`;
    try {
      const response = await api.post(`/medicationGroups`, { groupName, doctorId: `${user._id}` })

      const data = response.data
      return data
      logger.debug("Updated medicine new data:", data);
    } catch (error) {
      logger.error("Error updating medicine data:", error.message);
    }
  };

  const addMedicationGroupToDoctor = async (id) => {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/doctors/medicationgroups/${user._id}`;
    try {
      const response = await api.put(`/doctors/medicationgroups/${user._id}`, { medicationGroups: `${id}` })

      const data = response.data
      logger.debug("Updated medicine group to Doctor:", data);
      return data

    } catch (error) {
      logger.error("Error updating medicine data to Doctor:", error.message);
    }
  };

  const deleteMedicineGroupData = async (id) => {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/medicationGroups/${id}`;
    try {
      const response = await api.delete(`/medicationGroups/${id}`)

      logger.debug("Deleted medicine data:", id);
    } catch (error) {
      logger.error("Error deleting medicine data:", error.message);
    }
  };


  const addNewCard = async () => {
    try {
      let newGroup = await createMedicineNewData('New Group');
      try {
        await addMedicationGroupToDoctor(newGroup._id);
        logger.debug('Successfully added medication group to doctor', newGroup._id);
        await setMedicineData(prevData => [newGroup, ...prevData]);
        navigate(`/setting/managemedicinegroups/${newGroup._id}`);
      } catch (error) {
        await deleteMedicineGroupData(newGroup._id);
        logger.error("Error in second API call, created group deleted.");
      }
    } catch (error) {
      logger.error("Error in first API call.");
    }
  };

  const medicationGroupOptions = medicationGroup.map(group => ({
    label: group.groupName,
    value: group._id
  }));

  return (
    <div className="medi_left_container">
      <div className="medi_left_topbox">
        <div className="medi_left_header">
          <h3 className="medi_heading">Add New Groups</h3>
          <img
            className="medi_plus_icon"
            src={PlusIcon}
            alt="icon"
            onClick={addNewCard}
          />
        </div>
        <Dropdown
          className="my-dropdown--sidebar"
          placeholderClassName='myPlaceholderClassName'
          menuClassName='myMenuClassName'
          options={medicationGroupOptions}
          value={groups}
          placeholder="Select Group"
        />
      </div>
      <ManageMedicineCards medicineData={medicineData} MediRecordId={MediRecordId} />
    </div>
  );
};

export default MedicineSidebar;
